module.exports = __webpack_public_path__ + "img/product-smoke-44.0553dea1.jpg";